<template>
  <div id="request">
    <RequestMobile :leftPad="leftPad" :back="back" :cancel="cancel" :reply="reply" :isCurrentUser="isCurrentUser"
                   :request="request" :userReply.sync="userReply"
                   v-show="!$store.state.isDesktop"
    ></RequestMobile>

    <RequestDesktop :leftPad="leftPad" :back="back" :cancel="cancel" :reply="reply" :isCurrentUser="isCurrentUser"
                    :request="request" :userReply.sync="userReply"
                    v-show="$store.state.isDesktop"
    ></RequestDesktop>
  </div>
</template>

<script>

  import Requests from "../../core/Requests";
  import User from '../../core/User';
  import RequestMobile from '@/components/mobile/Request';
  import RequestDesktop from '@/components/desktop/Request';

  export default {

    name: "request",

    components: {
      RequestMobile,
      RequestDesktop
    },

    data() {
      return {
        Requests,
        userReply: "",
        CONFIG,
        User
      };
    },

    mounted() {
      this.$store.commit("setDisplay", {
        showHeader: true,
        showHeaderLeft: true,
        showFooter: true,
        headerTitle: "menu.requests",
        headerIcon: "/svg/history.svg"
      });
    },

    computed: {
      request: {
        get() {
          return this.Requests.get(this.$route.params.id);
        },
        set(data) {
          this.Requests.set(this.$route.params.id, data);
        }
      }
    },

    methods: {
      leftPad(str, length) {
        return leftPad(str, length, "0");
      },
      back() {
        this.$router.push("/requests");
      },
      isCurrentUser(id) {
        return this.User.id === id;
      },
      async cancel() {
        this.request.status = "canceled";
        showSpinner();
        let result = await this.Requests.cancelRequest(this.request);
        hideSpinner();
        if (result.status == 200) {
          this.$router.push("/requests");
        }
      },
      async reply() {
        if (this.userReply.length < 1) {
          return;
        }
        showSpinner();
        let result = await this.Requests.replyRequest(this.request, this.userReply);
        if (result.status == 200) {
          this.request = result.data;
          this.userReply = "";
        }
        hideSpinner();
      }
    }

  }

</script>

<style lang="scss" scoped>

  #request {
    background-color: #f2f3f4;
    display:flex;
  }

  .title {
    font-size: 20px;
    font-weight: 500;
  }
  .subtitle {
    font-size: 12px;
    color: #808b91;
    margin-bottom: 25px;
  }

  .section {
    display: flex;
    padding: 20px 0;
    border-top: 1px solid #d9dcde;
    .leftIcon {
      width: 20px;
      margin-right: 20px;
      padding-top: 6px;
      text-align: center;
      flex-shrink: 0;
      .svgicon {
        fill: #808b91;
      }
    }
    .content {
      flex-grow: 1;
    }
    .subtitle {
      color: #bfc5c8;
      text-transform: uppercase;
      font-size: 12px;
      margin: 0;
    }
    .line {
      display: flex;
      .grow {
        flex-grow: 1;
      }
    }
    .detailsLine {
      position: relative;
      margin-top: 10px;
      margin-bottom: 20px;
      .icon {
        position: absolute;
        left: -40px;
        .svgicon {
          fill: #808b91;
        }
      }
    }
  }

  .buttons {
    display: flex;
    .btn {
      flex-grow: 1;
      flex-basis: 0;
    }
    .btn:not(:last-of-type) {
      margin-right: 20px;
    }
  }

  .section-image {
    .content img {
      max-width: 100%;
      max-height: 200px;
      margin-top: 7px;
      border-radius: 10px;
    }
  }

</style>